var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlockWidthLarge = function SvgBlockWidthLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 14"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 11,
    x: 0.5,
    y: 1.5,
    fill: "currentColor",
    rx: 1
  })));
};
export default SvgBlockWidthLarge;